const actions = {
  async setApplicationLoadingToTrue({ commit }) {
    commit("setApplicationLoadingToTrue");
  },
  async setApplicationLoadingToFalse({ commit }) {
    commit("setApplicationLoadingToFalse");
  },
  async setComponentLoadingTrue({ commit }, property) {
    commit("setComponentLoadingTrue", property);
  },
  async setComponentLoadingFalse({ commit }, property) {
    commit("setComponentLoadingFalse", property);
  },
  async setErrors({ commit }, errors) {
    commit("setErrors", errors);
  }
};

export default actions;
